<template>
  <div>
    <div class="header-a">
      <div>
        <h3>开票日期</h3>
        <p>2020-09-12 15:16:22</p>
      </div>
      <div>
        <h3>发票类型</h3>
        <p>电子发票</p>
      </div>
      <div>
        <h3>发票抬头</h3>
        <p>张三</p>
      </div>
      <div>
        <h3>发票金额</h3>
        <p>¥10.00</p>
      </div>
      <div>
        <h3>发票内容</h3>
        <p>停车</p>
      </div>
    </div>
    <div class="header-b">
      <h3>接收方式</h3>
    </div>
    <div class="header-c">
      <div>
        <h3>电子邮箱</h3>
        <p>54883654@126.com</p>
      </div>
    </div>
    <div class="header-b">
      <h3>消费账单</h3>
    </div>
    <div class="header-d">
      <div>
        <h3>订单号</h3>
        <p>10005486</p>
      </div>
      <div>
        <h3>停车缴费-豫ACR128</h3>
        <p>¥10.00</p>
      </div>
      <div>
        <h3>入场时间</h3>
        <p>2020-09-10 11:26:47</p>
      </div>
      <div>
        <h3>开票金额</h3>
        <p>¥10.00</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped>

div h3 {
      font-size: 33px;
}

div p {
    font-size: 33px;
}
.header-a {
  height: 253px;
  background: #fff;
  margin: 30px;
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.header-a div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  margin: 0 40px;
}

.header-c {
  height: 50px;
  background: #fff;
  margin: 30px;
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.header-c div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  margin: 0 40px;
}

.header-b {
  margin: 0 40px;
  height: 50px;
  line-height: 50px;
}

.header-d {
  height: 253px;
  background: #fff;
  margin: 30px;
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.header-d div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
  margin: 0 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/detail.vue